import Header from "../layouts/header";
import Title from "../components/title";
import Footer from "../components/footer";
import FAQ from "../components/FAQ/FaqComponent";
import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";

export default function Tutorials(props) {
  const [t, i18next] = useTranslation("global");
  const language = localStorage.getItem("i18nextLng") || "es";

  useEffect(() => {
    document.body.classList.remove("dark-mode");
    document.title = "Preguntas Frecuentes - SAX"; 
  
    const metaDescription = document.querySelector('meta[name="description"]');
    const descriptionContent =
      "Consulta nuestras preguntas frecuentes para resolver tus dudas sobre SAX. Encuentra respuestas detalladas sobre registro, pagos, configuración y más.";
  
    if (metaDescription) {
      metaDescription.setAttribute("content", descriptionContent);
    } else {
      const newMetaDescription = document.createElement("meta");
      newMetaDescription.name = "description";
      newMetaDescription.content = descriptionContent;
      document.head.appendChild(newMetaDescription);
    }
  }, []);

  return (
    <>
      <Header {...props} />
      <Title title={t(`FAQ.title`)} subtitle={t(`FAQ.title2`)} />
      <FAQ />
      <Footer />
    </>
  );
}
